/**
 * @flow
 * @relayHash ad932590962fb27abb5360d4cf45867f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteQuotationSupplierMutationVariables = {|
  id: string
|};
export type DeleteQuotationSupplierMutationResponse = {|
  +deleteQuotationSupplier: {|
    +id: string
  |}
|};
export type DeleteQuotationSupplierMutation = {|
  variables: DeleteQuotationSupplierMutationVariables,
  response: DeleteQuotationSupplierMutationResponse,
|};
*/


/*
mutation DeleteQuotationSupplierMutation(
  $id: String!
) {
  deleteQuotationSupplier(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteQuotationSupplier",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "QuotationSupplierModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteQuotationSupplierMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteQuotationSupplierMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteQuotationSupplierMutation",
    "id": null,
    "text": "mutation DeleteQuotationSupplierMutation(\n  $id: String!\n) {\n  deleteQuotationSupplier(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8032f59b5fc9dcab306d53a58a013dd8';
module.exports = node;
